<template>
  <section class="payments-options" aria-labelledby="payments-options-title">
    <header class="payments-options__header">
      <DsChip label="Formas de pago" variant="orange" />

      <DsTextSplit
        id="payments-options-title"
        as="h3"
        base="Paga"
        highlight="como prefieras"
        base-color="var(--ds-purple-900)"
        highlight-color="var(--ds-purple-400)"
        class="payments-options__title"
      />

      <DsText as="body3" class="payments-options__intro">
        Todos los pagos están protegidos y se reflejan automáticamente.
      </DsText>
    </header>

    <div class="payments-options__cards">
      <PaymentsOptionCard
        v-for="card in cards"
        :key="card.id"
        :eyebrow="card.eyebrow"
        :title="card.title"
        :bullets="card.bullets"
        :illustration-src="card.illustrationSrc"
        :action-label="card.actionLabel"
        :note="card.note"
        :break-title-on-mobile="card.breakTitleOnMobile"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import paymentOptionBank from '../../../assets/pagos_payment_option_banco.svg'
import paymentOptionDomiciliation from '../../../assets/pagos_payment_option_domiciliacion.svg'
import paymentOptionSpei from '../../../assets/pagos_payment_option_spei.png'
import DsChip from '../atoms/DsChip.vue'
import DsText from '../atoms/DsText.vue'
import DsTextSplit from '../atoms/DsTextSplit.vue'
import PaymentsOptionCard from './PaymentsOptionCard.vue'

const cards = [
  {
    id: 'direct-debit',
    eyebrow: 'Domiciliación',
    title:
      '<span class="is-accent">Automático,</span> ' +
      '<span class="is-dark">sin olvidos.</span>',
    bullets: [
      'Solicita el formato de domiciliación',
      'Llena los datos y adjunta tus documentos',
      'Envía o entrega en sucursal'
    ],
    illustrationSrc: paymentOptionBank,
    actionLabel: 'Activar domiciliación',
    breakTitleOnMobile: false
  },
  {
    id: 'bank-payment',
    eyebrow: 'Pago en banco',
    title:
      '<span class="is-accent">Paga directamente</span> ' +
      '<span class="is-dark">en ventanilla</span>',
    bullets: [
      'Consulta tu referencia única',
      'Disponible en tu estado de cuenta',
      'Acude a tu banco con la referencia'
    ],
    illustrationSrc: paymentOptionDomiciliation,
    note:
      'Tu referencia única es un número exclusivo que identifica tus pagos.',
    breakTitleOnMobile: true
  },
  {
    id: 'spei-transfer',
    eyebrow: 'Transferencia SPEI',
    title:
      '<span class="is-accent">Rápido seguro</span> ' +
      '<span class="is-dark">e interbancario</span>',
    bullets: [
      'Entra a tu banca en línea',
      'Agrega la cuenta CLABE de destino',
      'Ingresa el monto exacto'
    ],
    illustrationSrc: paymentOptionSpei,
    breakTitleOnMobile: true
  }
]
</script>

<style scoped>
.payments-options {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  min-width: 0;
}

.payments-options__header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}

.payments-options__header :deep(.ds-chip) {
  padding: 8px;
  color: var(--ds-orange-800);
  background: var(--ds-orange-50);
  font-size: var(--ds-subtitle9-size);
  font-weight: var(--ds-subtitle9-weight);
  line-height: 16px;
}

.payments-options__title {
  font-size: var(--ds-h4-size);
  font-weight: var(--ds-h4-weight);
  line-height: 36px;
}

.payments-options__intro {
  max-width: 30ch;
  color: var(--ds-text-primary);
  line-height: 24px;
}

.payments-options__cards {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  width: 100%;
}

@media (min-width: 768px) {
  .payments-options {
    gap: 40px;
  }

  .payments-options__header {
    gap: 32px;
  }

  .payments-options__intro {
    max-width: none;
  }
}

@media (min-width: 1208px) {
  .payments-options {
    max-width: 962px;
    margin-right: auto;
    margin-left: auto;
  }

  .payments-options__title {
    font-size: var(--ds-h3-size);
    line-height: 44px;
  }

  .payments-options__cards {
    grid-template-columns: repeat(3, minmax(0, 305px));
    justify-content: center;
    gap: 20px;
  }
}
</style>
